import 'css-chunksrc/client/common/richTextInput/mentionList/styles.scss';export default {
  "mentionList": "_mentionList_18k2g_1",
  "item": "_item_18k2g_11",
  "active": "_active_18k2g_21",
  "avatar": "_avatar_18k2g_25",
  "info": "_info_18k2g_32",
  "name": "_name_18k2g_37",
  "profession": "_profession_18k2g_43"
};